import {useCallback} from 'react';
import {useFormikContext} from 'formik';
import {Drawer, DrawerFields} from 'components/customer/Product/entity/Drawer';
import {useAppSelector} from 'store/customer';
import {toNumber} from 'components/customer/Product/Drawer/helpers';
import {innerDrawerLimits} from 'components/customer/Product/Drawer/helpers/innerDrawerLimits';
import {useInnerDrawerGeometry} from 'components/customer/Product/Drawer/helpers/useInnerDrawerGeometry';

// what validation takes off the cabinet height above the top drawer: the
// rail's width when it is on edge, else the carcase thickness
export const useValidationTopPart = () => {
    const isRailOnEdge = useAppSelector(
        (state) => state.productData.isRailOnEdge
    );
    const railWidth = useAppSelector((state) => state.productData.railWidth);
    const carcaseThickness = useAppSelector(
        (state) => state.productData.carcaseThickness
    );

    return toNumber(isRailOnEdge ? railWidth : carcaseThickness);
};

// the drawers the count covers, top first
export const withinCount = (drawers: Drawer[] = [], drawerAmount: unknown) => {
    const amount = toNumber(drawerAmount);

    return amount > 0 ? drawers.slice(0, amount) : drawers;
};

// One set of limits for dragging, the arrows and typing a position alike.
export const useInnerDrawerLimits = () => {
    const {values} = useFormikContext<DrawerFields>();
    const geometry = useInnerDrawerGeometry();
    const topPart = useValidationTopPart();

    return useCallback(
        (index: number) =>
            innerDrawerLimits(index, {
                drawers: withinCount(values.drawers, values.drawer_amount),
                cabinetHeight: toNumber(values.cabinet_height),
                topPart,
                drawerTop: toNumber(values.cabinet_drawer_top),
                drawerBottom: toNumber(values.cabinet_drawer_bottom),
                geometry,
            }),
        [
            values.drawers,
            values.drawer_amount,
            values.cabinet_height,
            values.cabinet_drawer_top,
            values.cabinet_drawer_bottom,
            topPart,
            geometry,
        ]
    );
};
